import { useMemo, useRef } from "react";
import { useRefSize } from "../../../../../commons/hooks/useRefSize";
import { StyledCalendar } from "../../../../../styled/calendar";

const categoryMeta = [
    { key: "Ausentes", color: "black" },
    { key: "No Informados", color: "red" },
    { key: "Presentes", color: "blue" },
    { key: "Programados", color: "green" },
    { key: "Anulados", color: "grey" },
];

const TileContent = ({ appointments }) => {
    const ref = useRef(null);
    const [width] = useRefSize(ref);

    const sliceAmount = useMemo(() => {
        return Math.max(Math.floor((width - 10) / 40), 0);
    }, [width]);

    if (!appointments || appointments.length === 0) return null;

    const { counts, shown, remaining } = useMemo(() => {
        const counts = appointments.reduce(
            (acc, appointment) => {
                const estado = String(appointment.estado || "").toUpperCase();
                if (estado === "AUSENTES") acc["Ausentes"] += 1;
                else if (estado === "NO INFORMADOS") acc["No Informados"] += 1;
                else if (estado === "PRESENTES") acc["Presentes"] += 1;
                else if (estado === "PROGRAMADOS") acc["Programados"] += 1;
                else if (estado === "ANULADOS") acc["Anulados"] += 1;
                return acc;
            },
            { "Ausentes": 0, "No Informados": 0, "Presentes": 0, "Programados": 0, "Anulados": 0 }

        )

        const visibleCategories = categoryMeta.filter(({ key }) => counts[key] > 0);
        if (visibleCategories.length === 0) return null;
        const shown = visibleCategories.slice(0, sliceAmount)
        const remaining = visibleCategories.slice(sliceAmount);
        return { counts, shown, remaining }
    }, [appointments, sliceAmount]);

    return (
        <StyledCalendar.TileContentContainer ref={ref}>
            <StyledCalendar.ChipsRow>
                {shown.map(({ key, color }) => (
                    <StyledCalendar.TileContent
                        key={key}
                        as={StyledCalendar.State}
                        stateColor={color}
                        title={`${counts[key]} ${key}`}
                    >
                        {counts[key]}
                    </StyledCalendar.TileContent>
                ))}
            </StyledCalendar.ChipsRow>
            {remaining.length > 0 && (
                <StyledCalendar.MoreBadge
                    title={remaining.map(
                        ({ key }) =>
                            `${counts[key]} ${counts[key] === 1
                                ? key.slice(0, -1)
                                : key}`
                    ).join(", ")}
                >
                    +{remaining.length}
                </StyledCalendar.MoreBadge>
            )}
        </StyledCalendar.TileContentContainer>
    );
};

export default TileContent;